// import-dialog-data.token.ts
import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export interface ImportDialogData {
  title?: string;
  acceptLabel?: string;
  cancelLabel?: string;
  fileTypes?: string;
  endpoint?: string;
  /**
   * Ruta segun el archivo elegido, para los backends que piden datos del archivo en la URL (p. ej.
   * `?tipoArchivo=CSV`). Opcional: si no se declara, se usa {@link endpoint}.
   */
  endpointFor?: (file: File) => string;
  fieldName?: string;
  skipBackendEnrichment?: boolean;
  importMethod?: (file: File) => Observable<any>; // ← Nuevo campo
  /**
   * Ruta de la plantilla del importar (`GET .../import/plantilla`): un csv UTF-8 con el encabezado y
   * una fila de ejemplo, sin ids. Con ella el dialogo ofrece «Descargar plantilla» (Mantis #340).
   */
  templateUrl?: string;
  /** Nombre con que se guarda la plantilla descargada. */
  templateFileName?: string;
  /**
   * Funcionalidad que importa, como la nombran sus exportaciones (p. ej. `Dependencias`). Da el
   * nombre estandar del reporte de inconsistencias: `{empresa}-{funcionalidad}-Inconsistencias-
   * {fecha}.txt` (Mantis #430). Sin ella el reporte sale como `{empresa}-Inconsistencias-{fecha}.txt`.
   */
  funcionalidad?: string;
}

export const IMPORT_DIALOG_DATA = new InjectionToken<ImportDialogData>('IMPORT_DIALOG_DATA');
